export default __webpack_public_path__ + "static/media/bureau-veritas-certification@2x.b2e668ae.png";